import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ClockGlyph = /*#__PURE__*/createElement("g", {
  id: "clock",
  style: {
    transform: 'translate(18%, 18%) scale(2.85)'
  },
  strokeWidth: 0.5
}, /*#__PURE__*/createElement("path", {
  d: "M9.5 19C4.25271 19 0 14.7396 0 9.51718C0 4.29476 4.25271 0 9.5 0C14.7473 0 19 4.2604 19 9.51718C19 14.774 14.713 19 9.5 19ZM9.5 1.03074C4.83574 1.03074 1.02888 4.84448 1.02888 9.51718C1.02888 14.1899 4.83574 18.0036 9.5 18.0036C14.1643 18.0036 17.9711 14.1899 17.9711 9.51718C17.9711 4.84448 14.1643 1.03074 9.5 1.03074Z"
}), /*#__PURE__*/createElement("path", {
  d: "M10.25 8.63333V3.5C10.25 3.23333 10.0114 3 9.73864 3C9.46591 3 9.22727 3.23333 9.22727 3.5V8.63333C8.92046 8.76667 8.71591 9 8.57955 9.26667H5.51136C5.23864 9.26667 5 9.5 5 9.76667C5 10.0333 5.23864 10.2667 5.51136 10.2667H8.57955C8.78409 10.7 9.22727 11 9.73864 11C10.4545 11 11 10.4333 11 9.76667C11 9.23333 10.6932 8.8 10.25 8.63333Z"
}));
const Clock = createSvg({
  name: 'close',
  path: ClockGlyph
});

export default Clock;
export { ClockGlyph };
